// Divider.tsx
import React from 'react';
import './Divider.css';

interface DividerProps {
  type?: 'vertical' | 'horizontal';
  color?: string;
  spacing?: 'default' | 'compact';
}

const Divider: React.FC<DividerProps> = ({
  type = 'horizontal',
  color = '#E5E7EB',
  spacing = 'default',
}) => {
  return (
    <div
      className={`divider ${type} ${spacing === 'compact' ? 'compact' : ''}`}
      style={{ backgroundColor: color }}
    />
  );
};

export default Divider;
